// removed by extract-text-webpack-plugin
module.exports = {"donation":"_24jUf","avatar":"_2OgA8","information":"_1PUNL","date":"_25aFt","supporter":"_2jatY","message":"_3HOJA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Supporters/Supporter.scss
// module id = ./src/components/Supporters/Supporter.scss
// module chunks = 4